import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import { localizeDigits } from '@sohanscript/lib/utils/format';
import { Chip } from '@sohanscript/ui/chip';
import type * as React from 'react';
import type { Experience } from '#/lib/hooks/sohanemon.tsx';

type ExperienceDetailCardProps = React.ComponentProps<'div'> & {
	item: Experience;
};

export function ExperienceDetailCard({
	className,
	item,
	...props
}: ExperienceDetailCardProps) {
	return (
		<div className={cn('min-w-0 flex-[0_0_100%]', className)} {...props}>
			<div className="space-y-8 p-7 md:p-9">
				<div className="flex items-center justify-between gap-4 border-primary/15 border-b pb-6">
					<div>
						<p className="font-mono text-2xs text-muted-foreground uppercase tracking-[0.3em]">
							{m.experience_active_module()}
						</p>
						<h4 className="mt-2 font-black text-2xl text-foreground">
							{item.role}
						</h4>
					</div>
					<Iconify icon="lucide:terminal" className="h-8 w-8 text-primary" />
				</div>
				<p className="border-primary border-s ps-3 text-foreground/85">
					{item.summary}
				</p>

				<div className="corner-squircle rounded-2xl border border-primary/15 bg-background/60 p-5">
					<p className="font-mono text-2xs text-primary uppercase tracking-[0.28em]">
						{localizeDigits(item.metrics)}
					</p>
				</div>
				<ul className="space-y-3">
					{item.bullets.map((bullet) => (
						<li
							key={bullet}
							className="flex gap-3 text-muted-foreground text-sm leading-6"
						>
							<Iconify
								icon="lucide:check"
								className="mt-1 size-4 shrink-0 text-primary"
							/>
							<span>{localizeDigits(bullet)}</span>
						</li>
					))}
				</ul>
				<div className="flex flex-wrap gap-2">
					{item.stack.map((tech) => (
						<Chip key={tech}>{tech}</Chip>
					))}
				</div>
			</div>
		</div>
	);
}
